import type { HttpClient } from '@angular/common/http';
import type { TranslateLoader } from '@ngx-translate/core';
import { ConfigProperty, type ConfigService } from '@sds/shared';
import { Language } from '@sds/shared/enums';

export function translateLoaderFactory(http: HttpClient, configService: ConfigService) {
  return new SdsTranslateLoader(http, configService);
}

export class SdsTranslateLoader implements TranslateLoader {
  private crowdinPrefix: string;
  private readonly crowdinSuffix = `.json?${Date.now()}`;
  private readonly isDev =
    globalThis.location.href.includes('localhost') ||
    globalThis.location.href.match(/pr\d/)?.length ||
    globalThis.location.href.includes('newfair.enerest.world');

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly localPrefix = 'assets/i18n/',
    private readonly localSuffix = '.json'
  ) {}

  getTranslation(lang: string) {
    // crowdin uses the 6-char lol-US language code, but we can only use 5-char, so we need to map it to load the correct file
    if (lang === Language.LO_US) {
      lang = Language.LOL_US;
    }
    // the config is not available in the constructor, so we have to set it here just once
    if (!this.crowdinPrefix && !this.isDev && lang !== Language.LOL_US) {
      this.crowdinPrefix = (this.configService.get(ConfigProperty.CrowdinDistributionUrl) as string).replace(
        '{hash}',
        this.configService.get(ConfigProperty.CrowdinDistributionHash)
      );
    }

    return this.crowdinPrefix && lang !== Language.LOL_US
      ? this.http.get(`${this.crowdinPrefix}${lang}${this.crowdinSuffix}`)
      : this.http.get(`${this.localPrefix}${lang}${this.localSuffix}`);
  }
}
